export default "__VITE_ASSET__Chy1MnXf__"